import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Clickable, ClickEventListener, Focusable, FocusEventListener } from '@philips-emr/tws-core/lib/component/types';

class OptionAPI extends ComponentAPI implements Clickable, Focusable {

  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

  getRoute(): string {
    return this.state.route;
  }

  setRoute(route: string): void {
    this.setState({ route });
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  isEnabled(): boolean {
    return this.state.enabled;
  }

  isPreventDefault(): boolean {
    return this.state.preventDefault;
  }

  setPreventDefault(preventDefault: boolean): void {
    this.setState({ preventDefault });
  }

  isStopPropagation(): boolean {
    return this.state.stopPropagation;
  }

  setStopPropagation(stopPropagation: boolean): void {
    this.setState({ stopPropagation });
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }
}

export default OptionAPI;
